import * as XLSX from 'xlsx';
import { getExcelColumns } from './getExcel.helpers';
import { createTXT } from './createTXT';
import { downloadZip } from '@/utils/downloadFile';
import { buildAdvancedSearchDownloadRows } from './deduplicateSuggestions';

interface downloadAdvancedSearchResultsZipProps {
  suggestionsData: any[];
  searchType: string;
  selectedFilter: string;
  text: string;
  totalSearched: number;
  totalFound: number;
  selectedItems?: any[];
}

export const downloadAdvancedSearchResults = async ({
  suggestionsData,
  searchType,
  selectedFilter,
  text,
  totalSearched,
  totalFound,
  selectedItems,
}: downloadAdvancedSearchResultsZipProps) => {
  const rows = buildAdvancedSearchDownloadRows(suggestionsData, selectedItems);

  const columns = getExcelColumns(searchType, selectedFilter);

  const dataForExcel = rows.map(row => {
    const excelRow: any = {};

    columns.forEach(col => {
      excelRow[col.header] = col.value(row, row.__query);
    });

    return excelRow;
  });

  const worksheet = XLSX.utils.json_to_sheet(dataForExcel);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, 'Results');

  const excelBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
  });

  const metadataContent = createTXT({
    searchType,
    selectedFilter,
    text,
    totalSearched,
    totalFound,
  });

  const zipSuffix = selectedItems?.length ? 'selected' : 'all';

  await downloadZip({
    zipName: `advanced_search_${searchType.toLowerCase()}_${zipSuffix}`,
    files: [
      { name: `advanced_search_results.xlsx`, content: excelBuffer },
      { name: `advanced_search_metadata.txt`, content: metadataContent },
    ],
  });
};
